const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the user overview component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('presentationFile', [function() {
  return {
    scope: {
      cancel: '&',
      add: '&'
    },
    template: require('../../templates/directives/presentation-file.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.file = {};
      self.addFile = function() {
        $scope.add({file: self.file});
        self.file = null;
      };
      self.cancelFile = function() {
        self.file = null;
        $scope.cancel();
      };
      self.isEmpty = function(obj) {
        for(var prop in obj) {
            if(obj.hasOwnProperty(prop))
                return false;
        }
        return true;
    }
    }],
    controllerAs: 'presentationFile'
  }
}]);